import { action, makeObservable, observable } from 'mobx';
import { EnergyDataSet } from 'src/integration/types/EnergyDataSet';

class EnergyStore {
  @observable energy: EnergyDataSet[] = [];
  @observable version: number = Date.now();

  @action setEnergyData = (data: SimpleObject[]) => {
    this.energy = data as EnergyDataSet[];
    this.version = Date.now();
  };

  constructor() {
    makeObservable(this);
  }
}

export default EnergyStore;
